import { Autocomplete, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InvoiceAddressResponse } from 'src/modules/member/invoicerecipient/models/invoiceAddressResponse';
import ConsoleHelper from 'src/shared/functions/consoleHelper';

type ControlledSingleAutoCompleteInvoiceAddressProps = {
  name: string;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  categoryFilter?: number; // Not used
  options: InvoiceAddressResponse[];
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  onOptionSelect?: (arg: InvoiceAddressResponse) => void;
};

export const ControlledSingleAutoCompleteInvoiceAddress = (props: ControlledSingleAutoCompleteInvoiceAddressProps) => {
  const {
    name,
    placeholder = '',
    label = '',
    disabled = false,
    required = false,
    categoryFilter = 0,
    options,
    setQuery,
    onOptionSelect = undefined,
  } = props;

  const { t } = useTranslation();
  const { control } = useFormContext();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   const ListboxComponent = forwardRef<HTMLUListElement, any>((props, ref) => (
  //     <ul {...props} ref={ref}>
  //       {props.children}
  //       {hasNextPage && (
  //         <li style={{ display: 'flex', justifyContent: 'center', padding: '8px' }}>
  //           <Button onClick={() => fetchNextPage()} variant='outlined'>
  //             {t('common:showMore')}
  //           </Button>
  //         </li>
  //       )}
  //     </ul>
  //   ));

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Autocomplete
            role='listbox'
            fullWidth
            disabled={disabled}
            size='small'
            disableClearable
            getOptionLabel={(option) => option?.name ?? ''}
            filterOptions={(x) => x} // disable the built-in filtering of the Autocomplete component by overriding the filterOptions prop
            value={field.value || null}
            onChange={(_, newValue) => {
              field.onChange(newValue);
              ConsoleHelper.log('option', newValue);
              if (onOptionSelect) {
                onOptionSelect(newValue);
              }
              setQuery(''); // Rensa söksträngen när ett alternativ väljs
            }}
            onInputChange={(_, newInputValue) => {
              setQuery(newInputValue);
            }}
            id={name}
            // loading={isLoading}
            renderOption={(renderProps, option) => {
              return (
                <li {...renderProps} key={option?.id}>
                  {option?.name}
                </li>
              );
            }}
            // ListboxComponent={ListboxComponent}
            options={options}
            noOptionsText={t('order:autoComplete.noOptionsGeneric')}
            isOptionEqualToValue={(option, value) => option?.invoiceAddress_id === value?.invoiceAddress_id}
            renderInput={(params) => (
              <TextField
                {...params}
                required={required}
                variant='outlined'
                label={label}
                placeholder={placeholder}
                error={!!error}
                helperText={error?.message}
                sx={{}}
                InputProps={{
                  ...params.InputProps,
                  // Rensa söksträngen när användaren fokuserar på textfältet
                  onBlur: () => {
                    setQuery('');
                  },
                }}
              />
            )}
          />
        );
      }}
    />
  );
};
